import useExperience from 'canvas_states/experience/useExperience';
import useAppRouter from '../../hooks/useAppRouter';

const useIsShowWebCheckInComponents = () => {
  const { callbackUrl } = useAppRouter().states;
  const { experience } = useExperience().states;

  return {
    states: {
      isShowWebCheckInComponents: Boolean(experience?.isWebCheckInFlow && callbackUrl),
    },
  };
};

export default useIsShowWebCheckInComponents;
